module.exports = __webpack_public_path__ + "assets/img/wallet-icon2.c6209f33.png";